export const propertyLabels: { [key: string]: { label: string; ordem?: number }; } = {

    descricao: { label: "Descricao", ordem: 1 },
    descricaoCategoria: { label: "Categoria", ordem: 2 },
    periodoExtenso: { label: "Periodo", ordem: 3 },
    valorExtenso: { label: "Valor", ordem: 4 },
    dataCadastro: { label: "Data de Cadastro", ordem: 5 },
};

export const ModalTitulo = "Servico";
export const ModalTexto = "Deseja remover o Serviço?"
export const UrlServico = "Servico";
export const UrlBuscarPaginado = "Servico/BuscarPaginado";
export const UrlBuscarPermissao = "Servico";
export const urlPersistir = 'Servico';
export const UrlCategoriaServico = "Servico/Categoria";
export const PeriodoServico = 'Periodo';
export const BuscarPorColaborador = 'Servico/GetByColaboradorId';

